<template>
  <div>
    <slot />
    <img
      data-cy="pref-ring-central"
      src="/images/ringcentral.svg"
      class="h-3 cursor-pointer"
      :class="{
        'opacity-70 grayscale':
          preferredDialer !== CommunicationProvider.RingCentral,
      }"
      loading="lazy"
      @click="setPreferredDialer(CommunicationProvider.RingCentral)"
    />
    <img
      v-if="allowTwilioUse"
      data-cy="pref-twilio"
      src="/images/twilio.svg"
      class="mt-0-5 h-3 cursor-pointer"
      :class="{
        'opacity-70 grayscale':
          preferredDialer !== CommunicationProvider.Twilio,
      }"
      loading="lazy"
      @click="setPreferredDialer(CommunicationProvider.Twilio)"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { storeToRefs } from "pinia";

import { CommunicationProvider } from "@/enums/communicationProviders";
import { DEFAULT_DIALER } from "@/helpers/constants";
import { useAuth } from "@/hooks/auth";
import { useLocalStorageSetting } from "@/hooks/options";
import { useTwilioStore } from "@/stores/twilio";

const auth = useAuth();
const twilioStore = useTwilioStore();
const { userAssignedPhoneNumbers } = storeToRefs(twilioStore);

const preferredDialer = useLocalStorageSetting(
  "preferredDialer",
  DEFAULT_DIALER
);

const allowTwilioUse = computed(
  () => !!userAssignedPhoneNumbers.value?.length && auth.isLendflowUser
);

const setPreferredDialer = (type: CommunicationProvider) => {
  preferredDialer.value = type;
};
</script>
